<template>
    <transition name="overlay">
        <div class="overlay" v-if="$store.state.overlayStatus" @click="overlayStatus"></div>
    </transition>
</template>

<script>
export default {
    name: 'overlay',
    methods: {
        overlayStatus() {
            this.$store.commit('setModalStatus', false);
            this.$store.commit('setDesignFormStatus', false);
            this.$store.commit('setFreeOrderFormStatus', false);
            this.$store.commit('setFastBueStatus', false);
            this.$store.commit('setDirectorFormStatus', false);
            this.$store.commit('setCallbackStatus', false);
            this.$store.commit('setOverlayStatus', false);
            this.$store.commit('setMobileMenuStatus', false);
            document.body.classList.remove('_no-scroll');
        }
    }
}
</script>
